
import SystemOpsLayout from './SystemOpsLayout.vue'
import MessagingLayout from './messaging/MessagingLayout.vue'

export default {
  name: 'system-ops',
  label: 'System Ops',
  path: 'system-ops',
  link: 'system-ops',
  props: true,
  icon: 'wrench',
  description: 'Inspect operational delivery activity and diagnostics.',
  component: SystemOpsLayout,
  requireGetter: 'canViewAudit',
  breadcrumbLeaf: true,
  children: [
    {
      name: 'system-ops-message-delivery',
      label: 'Message Delivery',
      title: 'Message Delivery',
      icon: 'paper-plane',
      description: 'View history and status of sent messages.',
      path: 'message-delivery',
      beforeEnter: to => {
        if (to.name === 'system-ops-message-delivery') {
          return {
            name: 'system-ops-message-list',
            params: to.params,
            query: to.query,
            hash: to.hash
          }
        }
      },
      component: MessagingLayout,
      children: [
        {
          name: 'system-ops-message-list',
          navLabel: 'Message Delivery',
          navIcon: 'Mail',
          label: 'Messages',
          title: 'Messages',
          path: 'messages/:view?',
          component: () => import('./messaging/MessageList.vue')
        },
        {
          name: 'system-ops-message-recipient-list',
          navLabel: 'Message Recipients',
          navIcon: 'Contact',
          label: 'Recipients',
          title: 'Recipients',
          path: 'recipients/:view?',
          component: () => import('./messaging/MessageRecipientList.vue')
        },
        {
          name: 'system-ops-message-delivery-index',
          path: '',
          redirect: to => ({ name: 'system-ops-message-list', params: to.params })
        }
      ]
    }
  ]
}
